import React from "react";
import { createRoot } from "react-dom/client";
import ForgeCompiler from "./App.jsx";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ForgeCompiler />
  </React.StrictMode>,
);
